import type { FC } from "react";
import Subheading from "../atoms/typography/Subheading";
import { theme } from "../../theme";
import { useTranslation } from "react-i18next";
import ExpandAndCollapse from "../atoms/buttons/ExpandAndCollapse";
import styled from "styled-components";

interface Props {
  isExpanded: boolean;
  onClick: () => void;
  labelKey: string;
  labelSuffix?: string;
}

const CollapsedView = styled.div`
  background-color: ${theme.colors.grey02};
  border-radius: 12px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border: 1px solid ${theme.colors.grey05};
  width: fit-content;
  height: calc(100% - 16px);
  cursor: pointer;
`;

const RotatedText = styled(Subheading)`
  writing-mode: vertical-rl;
  text-orientation: mixed;
  transform: rotate(180deg);
`;

const ExpandAndCollapseTitleSection: FC<Props> = ({
  isExpanded,
  onClick,
  labelKey,
  labelSuffix,
}) => {
  const { t } = useTranslation();
  const label = labelSuffix ? `${t(labelKey)} ${labelSuffix}` : t(labelKey);

  return (
    <>
      {isExpanded ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 8,
          }}
        >
          <Subheading color={theme.colors.primary}>{label}</Subheading>
          <ExpandAndCollapse isExpanded={isExpanded} onClick={onClick} small />
        </div>
      ) : (
        <CollapsedView onClick={onClick}>
          <div onClick={(e) => e.stopPropagation()}>
            <ExpandAndCollapse
              isExpanded={isExpanded}
              onClick={onClick}
              small
            />
          </div>
          <RotatedText color={theme.colors.primary}>{label}</RotatedText>
        </CollapsedView>
      )}
    </>
  );
};

export default ExpandAndCollapseTitleSection;
